var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('icon-custom',{staticClass:"appear help mt-n1",attrs:{"title":_vm.timezone,"size":_vm.size,"name":"info","fill":"gray-3"}})}
var staticRenderFns = []

export { render, staticRenderFns }